import { Injectable, inject } from '@angular/core'

import { Observable, map, throwError } from 'rxjs'

import { MediaLibraryResource } from '@flowx/designer/modules/core/dictionary/media-library.dictionary'
import { ApiHttpProxyService } from '@flowx/designer/shared/api/api-http-proxy.service'

import { PaginationQueryParams } from './api-http.service'
import { MediaLibraryManager } from './media-library.api'

import { PaginatedResponse } from '../services/paginated-datasource'
import { UrlParametersStoreService } from '../services/url-parameters-store.service'

@Injectable({ providedIn: 'root' })
export class MediaLibraryPrivateApi extends ApiHttpProxyService implements MediaLibraryManager {
  #urlParametersStoreService = inject(UrlParametersStoreService)
  #cmsUrl = 'cms/api/media-library/files/private'
  #cmsUrlPublic = 'cms/api/media-library/files'

  getMediaLibraryResources<PrivateDocument>(
    params: PaginationQueryParams
  ): Observable<PaginatedResponse<PrivateDocument>> {
    return this.httpClient
      .get<PaginatedResponse<PrivateDocument>>(
        `${this.#getPrivateMediaLibraryBaseUrl()}/${this.#cmsUrl}`,
        {
          params: this.addParams(params ?? {}),
        }
      )
      .pipe(map((response: any) => response.resourceContent))
  }

  addFile(newFile: FormData): Observable<MediaLibraryResource> {
    return this.httpClient
      .post(`${this.#getPrivateMediaLibraryBaseUrl()}/with-file/${this.#cmsUrl}`, newFile)
      .pipe(map((response: any) => response.resourceContent))
  }

  updateImage(imageId: string, newImage: FormData): Observable<MediaLibraryResource> {
    return throwError(() => new Error('Method not implemented', { cause: { imageId, newImage } }))
  }

  deleteImage(id: string): Observable<any> {
    return this.httpClient.delete(
      `${this.#getMediaLibraryBaseUrl()}/ri/${id}/${this.#cmsUrlPublic}`
    )
  }

  exportMediaLibraryResources(params: any): Observable<PaginatedResponse<MediaLibraryResource>> {
    return throwError(() => new Error('Method not implemented', { cause: { params } }))
  }

  exportMediaLibraryResourcesWithBinaries(params: any): Observable<Blob> {
    return throwError(() => new Error('Method not implemented', { cause: { params } }))
  }

  importImages(payload: { images: MediaLibraryResource[] }): Observable<MediaLibraryResource[]> {
    return throwError(() => new Error('Method not implemented', { cause: { payload } }))
  }

  checkImageVersion(imageId: string): Observable<any> {
    return throwError(() => new Error('Method not implemented', { cause: { imageId } }))
  }

  #getPrivateMediaLibraryBaseUrl = (): string => {
    const { appId, appVersionId } = this.#urlParametersStoreService.urlParameters
    return `${this.getProxyBaseUrl(appId, appVersionId)}/rt/mediafile`
  }

  #getMediaLibraryBaseUrl = (suffix?: string): string => {
    const { appId, appVersionId } = this.urlParametersStoreService.urlParameters
    const proxyBaseUrl = suffix
      ? `${this.getProxyBaseUrl(appId, appVersionId)}}/${suffix}`
      : `${this.getProxyBaseUrl(appId, appVersionId)}`
    return `${proxyBaseUrl}/rt/mediafile`
  }
}
